import { authFetch } from './authFetch';

let schedulerId = null;
let watchId = null;
let lastSentAt = 0;

function romeMinutes() {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Rome',
      hourCycle: 'h23',
      hour: '2-digit',
      minute: '2-digit',
    })
      .formatToParts(new Date())
      .map((x) => [x.type, x.value])
  );

  return Number(parts.hour) * 60 +
    Number(parts.minute);
}

function inAutomaticWindow() {
  const m = romeMinutes();

  const prima =
    m >= 12 * 60 + 50 &&
    m <= 13 * 60 + 10;

  const seconda =
    m >= 13 * 60 + 50 &&
    m <= 14 * 60 + 10;

  return prima || seconda;
}

async function sendPosition(pos) {
  /*
   * Max un campione al minuto.
   */
  if (
    Date.now() - lastSentAt <
    60 * 1000
  ) {
    return;
  }

  lastSentAt = Date.now();

  try {
    await authFetch(
      '/api/localizzazione/ping',
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',
        },

        body: JSON.stringify({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy:
            pos.coords.accuracy,
          capturedAt: new Date(
            pos.timestamp || Date.now()
          ).toISOString(),
        }),
      }
    );
  } catch {
    /*
     * Nessun errore visibile:
     * il successivo campione riproverà.
     */
  }
}

function startWatch() {
  if (
    watchId !== null ||
    !navigator?.geolocation
  ) {
    return;
  }

  watchId =
    navigator.geolocation.watchPosition(
      sendPosition,

      () => {},

      {
        enableHighAccuracy: true,
        maximumAge: 60 * 1000,
        timeout: 20 * 1000,
      }
    );
}

function stopWatch() {
  if (
    watchId === null ||
    !navigator?.geolocation
  ) {
    return;
  }

  navigator.geolocation.clearWatch(
    watchId
  );

  watchId = null;
}

function syncState() {
  if (inAutomaticWindow()) {
    startWatch();
  } else {
    stopWatch();
  }
}

export function startWebLocationScheduler() {
  if (schedulerId !== null) {
    return () => {};
  }

  syncState();

  schedulerId = setInterval(
    syncState,
    30 * 1000
  );

  return stopWebLocationScheduler;
}

export function stopWebLocationScheduler() {
  stopWatch();

  if (schedulerId !== null) {
    clearInterval(schedulerId);
    schedulerId = null;
  }
}